const allZonesReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_ZONES':
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};

export default allZonesReducer;
